// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3lpt4","left":"InfoRow_left__2N4l2"};